/* Maison Sandrine — accessible, section-scoped Awards lightbox. */
(() => {
  const initialize = (root) => {
    const galleries = [];
    if (root.matches && root.matches('[data-ms-awards-gallery]')) galleries.push(root);
    if (root.querySelectorAll) galleries.push(...root.querySelectorAll('[data-ms-awards-gallery]'));

    galleries.forEach((gallery) => {
      if (gallery.dataset.msAwardsReady === 'true') return;
      const dialog = gallery.querySelector('[data-ms-awards-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const image = dialog.querySelector('[data-ms-awards-image]');
      const caption = dialog.querySelector('[data-ms-awards-caption]');
      const counter = dialog.querySelector('[data-ms-awards-counter]');
      const close = dialog.querySelector('[data-ms-awards-close]');
      const prev = dialog.querySelector('[data-ms-awards-prev]');
      const next = dialog.querySelector('[data-ms-awards-next]');
      const links = () => Array.from(gallery.querySelectorAll('.ms-bakery__award-link'));
      let current = 0;
      let opener = null;
      let touchStartX = null;

      const display = (index) => {
        const items = links();
        if (!items.length) return;
        current = (index + items.length) % items.length;
        const link = items[current];
        const thumbnail = link.querySelector('img');
        const label = link.querySelector('figcaption');
        image.src = link.href;
        image.alt = thumbnail ? thumbnail.alt : '';
        caption.textContent = label ? label.textContent.trim() : '';
        caption.hidden = !caption.textContent;
        counter.textContent = (current + 1) + ' / ' + items.length;
        prev.hidden = items.length < 2;
        next.hidden = items.length < 2;
      };

      gallery.addEventListener('click', (event) => {
        const link = event.target.closest('.ms-bakery__award-link');
        if (!link || !gallery.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        display(links().indexOf(link));
        if (!dialog.open) dialog.showModal();
        close.focus();
      });

      close.addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => display(current - 1));
      next.addEventListener('click', () => display(current + 1));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          display(current - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          display(current + 1);
        }
      });
      dialog.addEventListener('touchstart', (event) => {
        if (event.touches.length === 1) touchStartX = event.touches[0].clientX;
      }, { passive: true });
      dialog.addEventListener('touchend', (event) => {
        if (touchStartX === null || event.changedTouches.length !== 1) return;
        const distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) > 60) display(current + (distance < 0 ? 1 : -1));
      }, { passive: true });
      dialog.addEventListener('close', () => {
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      });
      gallery.dataset.msAwardsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
